import { render, staticRenderFns } from "./TeamShare.vue?vue&type=template&id=46b80adb&scoped=true&"
import script from "./TeamShare.vue?vue&type=script&lang=ts&"
export * from "./TeamShare.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b80adb",
  null
  
)

export default component.exports